module.exports = __webpack_public_path__ + "static/media/ZA.d58cd8c7.png";